import { AlertTriangle } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";

import { MyDayTickets } from "./MyDayTickets";
import { PulseCard } from "./PulseCard";
import { SignauxCard } from "./SignauxCard";

// Sprint 7 T7.5 + 10.x — TodayDevView, layout 2 colonnes :
// - Main (lg col-span-7) : TicketsCard
// - Side (lg col-span-5) : 3 cards (Bugs / Pulse / Signaux)
//
// Pulse produit : branché PostHog (Sprint 10.x posthog_pulse edge function).
// Signaux : branchés sur skill_runs (status='error' last 24h).
// Bugs critiques : reste placeholder Sentry (Phase à venir).

const PlaceholderCard = ({
  icon,
  title,
  subtitle,
  message,
}: {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  message: string;
}) => (
  <Card>
    <CardContent className="p-0">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-border">
        <span className="text-muted-foreground [&>svg]:size-4">{icon}</span>
        <h2 className="text-[14px] font-semibold text-foreground">{title}</h2>
        {subtitle && (
          <span className="ml-auto text-[11.5px] text-muted-foreground">
            {subtitle}
          </span>
        )}
      </div>
      <p className="text-[12.5px] text-muted-foreground px-4 py-4 leading-relaxed">
        {message}
      </p>
    </CardContent>
  </Card>
);

export const TodayDevView = () => (
  <div className="grid grid-cols-1 lg:grid-cols-12 gap-3">
    {/* Main */}
    <div className="lg:col-span-7 flex flex-col gap-3">
      <MyDayTickets />
    </div>

    {/* Side */}
    <div className="lg:col-span-5 flex flex-col gap-3">
      <PlaceholderCard
        icon={<AlertTriangle />}
        title="Bugs critiques · 24h"
        message="L'intégration Sentry / monitoring n'est pas branchée sur fabrik-1. Cette section affichera les erreurs critiques des dernières 24h dès que la synchronisation sera active."
      />
      <PulseCard />
      <SignauxCard />
    </div>
  </div>
);
